export {
  Close as DialogClose,
  Portal as DialogPortal,
  Root as Dialog,
  Trigger as DialogTrigger,
} from "@rn-primitives/dialog";
